/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketspayoutsshared2Inputs */

const en_ticketspayoutsshared2 = /** @type {(inputs: Ticketspayoutsshared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This profile’s income goes to the organization’s account.`)
};

const de_ticketspayoutsshared2 = /** @type {(inputs: Ticketspayoutsshared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Einnahmen dieses Profils gehen auf das Konto der Organisation.`)
};

/**
* | output |
* | --- |
* | "This profile’s income goes to the organization’s account." |
*
* @param {Ticketspayoutsshared2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketspayoutsshared2 = /** @type {((inputs?: Ticketspayoutsshared2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketspayoutsshared2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketspayoutsshared2(inputs)
	return de_ticketspayoutsshared2(inputs)
});
export { ticketspayoutsshared2 as "ticketsPayoutsShared" }